const tokenize = (value) => {
  if (value === undefined || value === null) {
    return [];
  }
  if (Array.isArray(value)) {
    return value;
  }
  return String(value)
    .split(/[,\s]+/)
    .filter(Boolean);
};

// Invalid tokens are reported, not dropped, so a typo can't silently shrink the saved ID set.
export const parseWarehouseIdList = (value) => {
  const ids = [];
  const duplicates = [];
  const invalidTokens = [];

  tokenize(value).forEach((token) => {
    if (token == null) return;
    const raw = String(token).trim();
    if (!raw) return;
    if (!/^\d+$/.test(raw) || Number(raw) <= 0) {
      invalidTokens.push(raw);
      return;
    }
    const id = Number(raw);
    if (ids.includes(id)) duplicates.push(id);
    else ids.push(id);
  });

  return { ids, duplicates, invalidTokens };
};

export const parseRegionList = (value) => {
  const regions = [];
  const duplicates = [];

  tokenize(value).forEach((token) => {
    if (token == null) return;
    const region = String(token).trim().toUpperCase();
    if (!region) return;
    if (regions.includes(region)) duplicates.push(region);
    else regions.push(region);
  });

  return { regions, duplicates, invalidTokens: [] };
};
